import React from "react";
import { InertiaLink } from "@inertiajs/inertia-react";
import { Container } from "@/Components/Container";
import { User } from "react-feather";

const ExternalLayout = ({ children }) => {
  return (
    <>
      <div className="modal-hidden md:modal-block flex min-h-screen flex-col bg-background">
        <header className="w-full border-b-[1px] border-b-[#e9eceb] bg-background ">
          <Container
            size="max-w-[1440px]"
            className="flex w-full justify-between py-4"
          >
            <div className="flex items-center">
              <InertiaLink href="/" aria-label="Go to startpage">
                <img src="/images/gidas_logo_new.svg" alt="Emma" />
              </InertiaLink>
            </div>

            <div className="flex items-center">
              <ul className="flex">
                <li>
                  <InertiaLink
                    href="/login"
                    className="flex h-full cursor-pointer select-none items-center whitespace-nowrap px-4 py-2 hover:bg-gray"
                  >
                    <User
                      className="mr-2 inline w-10 rounded-full bg-primary p-2 text-center font-semibold text-white"
                      size={40}
                    />
                    <span className="ml-2">Log in</span>
                  </InertiaLink>
                </li>
              </ul>
            </div>
          </Container>
        </header>

        <main>{children}</main>

        {/*<footer className="mt-auto w-full bg-blue-dark py-16">*/}
        {/*  <Container*/}
        {/*    size="max-w-[1024px]"*/}
        {/*    className="flex w-full flex-col justify-between py-4 text-white md:flex-row"*/}
        {/*  >*/}
        {/*    <div className="mb-8 max-w-[240px] md:mb-0">*/}
        {/*      <ul>*/}
        {/*        <li className="mb-4">*/}
        {/*          <InertiaLink*/}
        {/*            className="hover:underline"*/}
        {/*            href="/terms-of-service"*/}
        {/*          >*/}
        {/*            Terms and conditions*/}
        {/*          </InertiaLink>*/}
        {/*        </li>*/}
        {/*        <li className="mb-4">*/}
        {/*          <InertiaLink className="hover:underline" href="/login">*/}
        {/*            Login*/}
        {/*          </InertiaLink>*/}
        {/*        </li>*/}
        {/*      </ul>*/}
        {/*    </div>*/}

        {/*    <div className="max-w-[320px]">*/}
        {/*      <img src="/images/logo.png" alt=""></img>*/}
        {/*      <p className="mt-2 block text-white">*/}
        {/*        En del av Gidås hållbarhetsbyrå och Dille Bolagen - Östersund*/}
        {/*      </p>*/}
        {/*    </div>*/}
        {/*  </Container>*/}
        {/*</footer>*/}
      </div>
    </>
  );
};

export default ExternalLayout;
